import React from 'react'

import {
  Grid,
  Span,
  InputFile,
  TableCellStyled,
  TableContainerStyled,
  TableBodyStyled,
  TableRowStyled,
  TableHeadStyled,
  TableStyled,
  Row
} from 'components'
import { DeleteIcon, ViewFileIcon } from 'components/Icons'
import { useAuth, useFile } from 'hooks'
import { IEvidenciaMovMensal } from 'pages/Supplier/MovMensal/types'
import { SPACING } from 'utils'
import FormatarNumeros from 'utils/formatNumbers'
export interface IAnexarEvidencias {
  listFiles: IEvidenciaMovMensal[]
  bloquearAcoes: boolean
  onPutFile: (_files) => void
  deleteEvidencia: (_index) => void
}

const AnexarEvidencias: React.FC<IAnexarEvidencias> = ({
  listFiles,
  bloquearAcoes,
  onPutFile,
  deleteEvidencia
}) => {
  const { viewFile } = useFile()

  const formatDate = (date: Date) => FormatarNumeros.formatDate(date);
  const returnExistingFormattedDate = (dateString: string) => FormatarNumeros.returnExistingFormattedDate(dateString);

  const currentDate = new Date();
  const matricula = useAuth().usuarioCsn.NmMatricula;

  return (
    <>
      <Span text="ANEXAR EVIDÊNCIAS" fontWeight="700" fontSize="16px" />
      <Grid
        gridCols="6fr 3fr"
        gridGap={`0 ${SPACING.spacing20}`}
        margin={`${SPACING.spacing20} 0 ${SPACING.spacing30} 0`}
      >
        <InputFile
          renderInput={false}
          disabled={bloquearAcoes}
          onChange={onPutFile}
        />
      </Grid>

      <Grid
        gridCols="12fr"
        gridGap={`0 ${SPACING.spacing20}`}
        margin={`${SPACING.spacing20} 0 ${SPACING.spacing30} 0`}
      >
        <TableContainerStyled>
          <TableStyled>
            <TableHeadStyled>
              <TableRowStyled>
                <TableCellStyled align="left" minwidth="300px"> Nome do arquivo</TableCellStyled>
                <TableCellStyled align="left">Descrição / Observação</TableCellStyled>
                <TableCellStyled align="left">Data</TableCellStyled>
                <TableCellStyled align="left">Usuário Matricula</TableCellStyled>
                <TableCellStyled align="center">Ações</TableCellStyled>
              </TableRowStyled>
            </TableHeadStyled>
            <TableBodyStyled>
              {listFiles?.length < 1 ? (
                <TableRowStyled>
                  <TableCellStyled colSpan={12} align="center">
                    Sem evidencias
                  </TableCellStyled>
                </TableRowStyled>
              ) : (
                listFiles?.map((el) => (
                  <TableRowStyled key={el?.dsDocumento.toString()}>
                    <TableCellStyled align="left"> {el.dsDocumento} </TableCellStyled>
                    <TableCellStyled align="left"> {el.dsExtensaoDoc} </TableCellStyled>
                    <TableCellStyled align="left"> {returnExistingFormattedDate(el?.dtAnexo) || formatDate(currentDate)} </TableCellStyled>
                    <TableCellStyled align="left"> {el?.usuarioMatricula || matricula} </TableCellStyled>
                    <TableCellStyled align="center">
                      <Row alignItems="center" justifyContent="center">
                        <ViewFileIcon
                          onClick={() =>
                            viewFile({
                              gedExternalID: el.documentoExternoGedId,
                              local: {
                                base64: el.base64,
                                filename: el.dsDocumento
                              }
                            })
                          }
                          cursor="pointer"
                          marginRight={SPACING.spacing10}
                        />
                        <DeleteIcon
                          disabled={bloquearAcoes}
                          onClick={() => deleteEvidencia(el)}
                        />
                      </Row>
                    </TableCellStyled>
                  </TableRowStyled>
                ))
              )}
            </TableBodyStyled>
          </TableStyled>
        </TableContainerStyled>
      </Grid>
    </>
  )
}

export default AnexarEvidencias
